/**
 * Lightweight session state helpers.
 *
 * Auth tokens are now stored exclusively in httpOnly cookies (set by the
 * server, invisible to JavaScript). This file only tracks the non-sensitive
 * UI flags needed for client-side routing and deriving the current user's ID.
 *
 * sessionStorage is used so the state is scoped to the browser tab and is
 * automatically cleared when the tab or browser is closed.
 */

const AUTH_KEY = 'isAuthenticated';
const USER_ID_KEY = 'userId';

/**
 * Called after a successful login.
 * @param {string} userId - The authenticated user's auth_id (non-sensitive UUID).
 */
export const setAuthenticated = (userId) => {
    sessionStorage.setItem(AUTH_KEY, 'true');
    sessionStorage.setItem(USER_ID_KEY, userId);
};

/** Called on logout or 401. Clears all session flags. */
export const clearAuthenticated = () => {
    sessionStorage.removeItem(AUTH_KEY);
    sessionStorage.removeItem(USER_ID_KEY);
};

/** Returns true if the user has an active session in this tab. */
export const isAuthenticated = () => sessionStorage.getItem(AUTH_KEY) === 'true';

/**
 * Returns the current user's UUID (stored after login for UI purposes only).
 * This is not used for auth — the server validates the httpOnly cookie.
 */
export const getUserId = () => sessionStorage.getItem(USER_ID_KEY);
